import eventListeners from './event-listeners';
import documentCutHandler from '../handlers/document-cut-handler';

const cutListener = (element) => {
  eventListeners.add(element, 'cut', documentCutHandler);
};

export default cutListener;
